import { CourseAuthor } from "@jelly/lesson";
import appConfig from "appConfig";

const author: CourseAuthor = {
  name: "Francisco Castells",
  title: "Associate Professor at Universitat Politècnica de València, Spain;ASKNOW Reviewer and contributor",
  description: `
Francisco Castells was born in Spain in 1976. He graduated in Telecommunications Engineering at Universitat Politècnica de València (UPV) in 2000, and obtained his Ph.D. degree in Electronics Engineering in 2006, also at UPV. He started his academic career in 2002, when he became lecturer at the Electronics Engineering department at UPV. Since 2008 he is lecturer in Electroacoustics at the Master in Acoustics Engineering at UPV. He has also lectured Electroacoustics at the Erasmus Mundus Joint Degree Master WAVES (Waves, Acoustics, Vibration, Engineering and Sound). As a researcher, he is interested in instrumentation and signal processing with applications in sound and biomedical engineering, and has published over 40 papers in peer-reviewed journals (h-index 20).



  <ul>
    <li><a href="https://www.master-waves.eu/" target="_blank">https://www.master-waves.eu/</a></li>
    </ul>
  `,
  imageUrl: appConfig.ASSETS_URL + "/avatar-placeholder.png",
};

export default author;
